if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js')
    .then(reg => console.log('service worker registered'))
    .catch(err => console.log('service worker not registered', err));
}
import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import Select2 from './Components/Select2';
import { ValidationProvider } from 'vee-validate';
import { abilitiesPlugin } from '@casl/vue';
import VueToastr from 'vue-toastr';
import TimoraHelper from './Plugins/TimoraHelper';
import ServiceModule from './Plugins/ServiceModule';
import PermissionHelper from './Plugins/PermissionHelper';
import Services from './Misc/Services';
import VPopover from 'vue-js-popover';
import router from './Router/index';
import store from './Store/index';
import { consumePendingPushRedirect } from './Plugins/PushRedirect';
import VueClipboard from 'vue-clipboard2';
import App from './App.vue';
import Fragment from 'vue-fragment';
import vClickOutside from 'v-click-outside';
import { updateHandler, handlers } from './Plugins/utils';
import Vuelidate from 'vuelidate';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import Pusher from 'pusher-js';
import Particles from '@tsparticles/vue2';
import { loadSlim } from '@tsparticles/slim';
const pusher = new Pusher(`${process.env.MIX_PUSHER_APP_KEY}`, {
  cluster: 'ap2'
});
Vue.prototype.$pusher = pusher;
require('./bootstrap');
// import CssBase from "css-loader/lib/css-base";
// import AddStyles from "style-loader/lib/addStyles";
import '@/mixins/GlobalComponentsFile';
import VueMask from 'v-mask';
Vue.use(VueMask);
Vue.use(Vuelidate);
Vue.use(VueTelInput);
Vue.use(VueClipboard);
Vue.use(Particles, {
  init: async engine => {
    await loadSlim(engine);
  }
});
Vue.use(Fragment.Plugin);
Vue.use(TimoraHelper);
Vue.use(PermissionHelper);
Vue.use(VueRouter);
Vue.use(vClickOutside);
Vue.use(VPopover, { tooltip: true });
Vue.use({
  install(Vue) {
    Vue.prototype.$services = Services;
    Vue.prototype.$service = {
      create: ServiceModule.create,
      retrieve: ServiceModule.retrieve,
      update: ServiceModule.update,
      delete: ServiceModule.delete
    };
    Vue.prototype.$hold = function (fn, time = 10) {
      setTimeout(() => fn(), time);
    };
  }
});

Vue.component('Select2', Select2);
Vue.component('ValidationProvider', ValidationProvider);
Vue.use(VueToastr, {
  defaultTimeout: 3000,
  defaultPosition: 'toast-bottom-left',
  defaultClassNames: 'active'
});

Vue.use(abilitiesPlugin, store.getters['abilities/getAbilities'], {
  useGlobalProperties: true
});

Vue.config.devtools = true;
Vue.config.debug = true;

Vue.directive('autoheight', {
  bind(el, binding, vnode) {
    const minHeight = binding.value;

    if (_.isNumber(minHeight)) {
      function setHeight() {
        $(el).height(minHeight + 'px');
        el.style.height = minHeight + 'px';
        const scrollHeight = el.scrollHeight;
        if (scrollHeight + 2 > minHeight) {
          el.style.height = scrollHeight + 2 + 'px';
        }
      }

      $(el).on('input', setHeight);
      setHeight();
    }
  },
  unbind(el, binding, vnode) {
    $(el).off();
  }
});

Vue.directive('avatarPlaceholder', {
  bind(el) {
    const fallback = '/images/avatar-users.png';
    const isBadSrc = src => {
      if (!src || typeof src !== 'string') {
        return true;
      }
      const s = src.trim();
      return (
        !s ||
        s === '/storage/' ||
        s === '/storage' ||
        s === 'null' ||
        s === 'undefined'
      );
    };
    if (isBadSrc(el.getAttribute('src'))) {
      el.src = fallback;
    }
    el.onerror = () => {
      if (el.src && !el.src.endsWith(fallback)) {
        el.src = fallback;
      }
    };
  },
  update(el) {
    const fallback = '/images/avatar-users.png';
    const src = el.getAttribute('src');
    if (
      !src ||
      src.trim() === '/storage/' ||
      src.trim() === '/storage' ||
      src.trim() === 'null' ||
      src.trim() === 'undefined'
    ) {
      el.src = fallback;
    }
  }
});

Vue.directive('maxlen', {
  bind: updateHandler,
  update: updateHandler,
  unbind(el) {
    el.removeEventListener('input', handlers.get(el));
    handlers.delete(el);
  }
});

axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post.Accept = 'application/json';
//
// axios.interceptors.response.use(
//   function (response) {
//     return response;
//   },
//   function (error) {
//     if (error.response.status === 401) {
//       store.dispatch('auth/signOut');
//       router.push({ name: 'SignIn' });
//     }
//     return Promise.reject(error);
//   }
// );

// document.getElementsByClassName('select2-results__option select2-results__message')[0].innerHTML = 'dsds';
store.dispatch('settings/updateSettings');
store.dispatch('auth/me').then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');

  // See public/sw.js's notificationclick handler: on iOS PWAs, launching
  // the app from a push notification can silently drop the target URL and
  // open at the manifest's start_url instead — the real URL is stashed in
  // IndexedDB there, so pick it up here once the router is ready.
  consumePendingPushRedirect().then(url => {
    if (url) {
      router.push(url).catch(() => {});
    }
  });
});
